import React from "react";
import { Container, Typography, Box, Grid, Paper, Stack } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import GroupsIcon from "@mui/icons-material/Groups";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import FactoryIcon from "@mui/icons-material/Factory";
import SectionHeading from "./SectionHeading";
import { colors, fonts, ui } from "../theme";

const teamMembers = [
  { name: "RASHEEDHA R", title: "Founder & Head of Operations" },
  { name: "RAZAK MOHAMED S", title: "Head of Technology & Talent Development" },
  { name: "ANNAMALAI S", title: "Development Manager" },
];

const challenges = [
  {
    icon: <SchoolIcon />,
    title: "Student Readiness",
    text: "Limited practical problem-solving in DSA leaves students underprepared for competitive technical placements.",
  },
  {
    icon: <GroupsIcon />,
    title: "Faculty Bandwidth",
    text: "Heavy teaching loads limit exposure to fast-changing pipelines like Docker, Kubernetes and cloud systems.",
  },
  {
    icon: <AccountBalanceIcon />,
    title: "Accreditation Load",
    text: "Compiling verifiable documentation for NAAC Criterion 3 & 5 through manual processes is difficult and slow.",
  },
  {
    icon: <FactoryIcon />,
    title: "Industry Gap",
    text: "Industry now demands full-stack APIs, live cloud platforms and DevOps — beyond basic software roles.",
  },
];

const About = () => {
  return (
    <section id="about-section" className="about-section">
      <Box sx={{ background: colors.bgGradient, py: { xs: 5, md: 7 } }}>
        <Container>
          <SectionHeading
            eyebrow="About Crescent EdTech"
            title="A Deeply Embedded Research & Innovation Enablement Partner"
            subtitle="Established in 2024 by Mrs. Rasheedha R, Crescent EdTech rejects the transactional model of template projects and generic certificates. Instead, we integrate continuous technical mentorship and institutional compliance data streams directly into your departments — building lasting academic value through a long-term MoU rather than seasonal vendor engagements."
          />

          <Grid container spacing={3} sx={{ mb: 2 }}>
            {challenges.map((c) => (
              <Grid item xs={12} sm={6} md={3} key={c.title}>
                <Paper
                  elevation={0}
                  sx={{
                    ...ui.cardHover,
                    p: 3,
                    height: "100%",
                    borderRadius: 3,
                    border: "1px solid #e6edf7",
                    bgcolor: colors.white,
                  }}
                >
                  <Box
                    sx={{
                      width: 46,
                      height: 46,
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: colors.blueTint,
                      color: colors.blueDark,
                      border: "1px solid rgba(56,182,255,0.22)",
                      mb: 1.8,
                    }}
                  >
                    {c.icon}
                  </Box>
                  <Typography
                    sx={{ fontFamily: fonts.heading, fontWeight: 700, color: colors.navy, mb: 0.8 }}
                  >
                    {c.title}
                  </Typography>
                  <Typography sx={{ color: colors.textMuted, fontSize: "0.92rem", lineHeight: 1.6 }}>
                    {c.text}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

          {/* Team */}
          <Box sx={{ mt: 7 }}>
            <SectionHeading eyebrow="Leadership" title="Know Our Team" />
            <Grid container spacing={3} justifyContent="center">
              {teamMembers.map((member) => (
                <Grid item xs={12} sm={6} md={4} key={member.name}>
                  <Paper
                    elevation={0}
                    sx={{
                      ...ui.cardHover,
                      p: 3,
                      textAlign: "center",
                      borderRadius: 3,
                      border: "1px solid #e6edf7",
                      bgcolor: colors.white,
                      height: "100%",
                    }}
                  >
                    <Stack alignItems="center" spacing={1.5}>
                      <Box
                        sx={{
                          width: 68,
                          height: 68,
                          borderRadius: "50%",
                          background: colors.brandGradient,
                          color: colors.white,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontFamily: fonts.heading,
                          fontWeight: 700,
                          fontSize: "1.4rem",
                        }}
                      >
                        {member.name.charAt(0)}
                      </Box>
                      <Typography sx={{ fontFamily: fonts.heading, fontWeight: 700, color: colors.navy }}>
                        {member.name}
                      </Typography>
                      <Typography sx={{ color: colors.blueInk, fontWeight: 600, fontSize: "0.9rem" }}>
                        {member.title}
                      </Typography>
                    </Stack>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>
    </section>
  );
};

export default About;
